module.exports = __webpack_public_path__ + "media/static/icons/icon-beach-6ae14c4ec8e42564694f215c133333b9.svg";